import { useEffect, useState } from "react";
import {
  ComboBox,
  ComboBoxChangeEvent,
  ComboBoxFilterChangeEvent,
} from "@progress/kendo-react-dropdowns";
import {
  RadioButton,
  TextArea,
  RadioButtonChangeEvent,
  TextAreaChangeEvent,
} from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { CourseResult, Schedule } from "@mikros/library";
import { Error } from "@progress/kendo-react-labels";
import { FormattedMessage, useIntl } from "react-intl";
import { filterBy } from "@progress/kendo-data-query";

export interface CourseProps {
  schedule: Schedule;
  onStepperChange: (schedule: Schedule) => void;
  courseResults: CourseResult;
}

export function Course(props: CourseProps) {
  const intl = useIntl();
  const [isUserRespReqrd, setIsUserRespReqrd] = useState<boolean>(
    props.schedule.isUserRespReqrd
  );

  const [templateLanguage, setTemplateLanguage] = useState<string>(
    intl.formatMessage({ id: "schedule.course.templateLanguage.English" })
  );
  const [languageCode, setLanguageCode] = useState<string>(
    intl.formatMessage({ id: "schedule.course.languageCode.english" })
  );
  const [courseName, setCourseName] = useState<string>();
  const [description, setDescription] = useState<string>();
  const [errors, setErrors] = useState<any>({});
  const [courseData, setCourseData] = useState<string[]>([]);

  const languageMapping: Record<string, string> = {
    English: intl.formatMessage({ id: "schedule.course.languageCode.english" }),
    Tamil: intl.formatMessage({ id: "schedule.course.languageCode.tamil" }),
  };
  const languageCodeToLanguage: Record<string, string> = {
    en_US: intl.formatMessage({
      id: "schedule.course.templateLanguage.English",
    }),
    ta: intl.formatMessage({ id: "schedule.course.templateLanguage.Tamil" }),
  };
  console.log("print the template language choosen", templateLanguage);
  console.log("print the language code", languageCode);

  console.log("print error", errors);

  const handleIsUserRespReqrd = (e: RadioButtonChangeEvent) => {
    setIsUserRespReqrd(e.value);
  };

  const handleCourseName = (e: ComboBoxChangeEvent) => {
    setCourseName(e.value);
  };

  const handleWelcomeMessage = (e: TextAreaChangeEvent) => {
    setDescription(e.value);
  };

  const validate = () => {
    if (courseName !== undefined && isUserRespReqrd !== undefined) {
      return true;
    }
    let err: any = {};
    if (!courseName) {
      err.courseName = {
        error: intl.formatMessage({ id: "schedule.course.selectCourse" }),
      };
    }
    if (isUserRespReqrd === undefined) {
      err.isUserRespReqrd = {
        error: intl.formatMessage({ id: "schedule.course.selectOption" }),
      };
    }
    setErrors(err);
    return false;
  };

  const handleCourseDataChange = () => {
    if (validate()) {
      let schedule: Schedule = props.schedule;

      let selectedCourse = props.courseResults.resources?.find((element) => {
        if (element.courseName === courseName) {
          return element;
        }
      });
      schedule.courseName = courseName!!;
      schedule.languageCode = languageCode;
      schedule.description = description!!;
      schedule.isUserRespReqrd = isUserRespReqrd!!;
      schedule.courseId = selectedCourse!!.courseId;
      schedule.accntId = selectedCourse!!.accntId;
      schedule.cardCnt = selectedCourse?.cardCount!!;
      schedule.chapterCnt = selectedCourse?.chapterCount!!;
      schedule.assessQuesCnt = selectedCourse?.minAsmtCnt!!;
      schedule.minCardCntChpt = selectedCourse?.minCrdCnt!!;
      schedule.maxCardCnt= selectedCourse?.maxCardCnt!!;

      console.log("print the schedule details", schedule);

      props.onStepperChange(schedule);
    }
  };

  useEffect(() => {
    setIsUserRespReqrd(props.schedule.isUserRespReqrd);
    setDescription(props.schedule.description);
    setCourseName(props.schedule.courseName);
    setTemplateLanguage(languageCodeToLanguage[props.schedule.languageCode!!]);
  }, []);

  useEffect(() => {
    if (props.courseResults) {
      console.log("It's inside course Schedule", props.courseResults);
      const courseNames = props.courseResults.resources?.map((ele) => {
        return ele.courseName;
      });
      console.log("This is the course Name", courseNames);
      setCourseData(courseNames);
    }
  }, [props.courseResults]);

  const handleFilterChange = (e: ComboBoxFilterChangeEvent) => {
    const data = filterBy(
      props.courseResults.resources?.map((element, index) => {
        return element.courseName;
      }),
      e.filter
    );
    setCourseData(data);
  };
  
  return (
    <div className="w-full h-full overflow-auto space-y-8">
      <div className="w-full">
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.courseName" />
        </h4>
        <Error>{errors.courseName?.error}</Error>
        <div className="ps-20 pt-2">
          <ComboBox
            data={courseData}
            onFilterChange={(e: ComboBoxFilterChangeEvent) => {
              handleFilterChange(e);
            }}
            onChange={handleCourseName}
            filterable={true}
            className="w-56 md:w-96"
            value={courseName}
            placeholder={intl.formatMessage({ id: "schedule.course.select" })}
          />
        </div>
      </div>

      <div className="w-full">
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.courseOptions" />
        </h4>
        <Error>{errors.isUserRespReqrd?.error}</Error>
        <div className="ps-20 pt-2 flex  items-center">
          <RadioButton
            name="CourseOption"
            value={true}
            checked={isUserRespReqrd === true}
            label={intl.formatMessage({
              id: "schedule.createSchedule.courseOption1",
            })}
            onChange={handleIsUserRespReqrd}
          />
        </div>
        <div className="ps-20 pt-2 flex items-center">
          <RadioButton
            name="CourseOption"
            value={false}
            checked={isUserRespReqrd === false}
            label={intl.formatMessage({
              id: "schedule.createSchedule.courseOption2",
            })}
            onChange={handleIsUserRespReqrd}
          />
        </div>
      </div>
      <div className="pe-4 w-full">
        <div className="flex flex-row">
          <h4 className="font-bold ">
            <FormattedMessage id="schedule.createSchedule.welcomeMessage" />
          </h4>{" "}
          <p className="text-mk-grey text-sm flex items-center ps-1">
            {/* (optional) */}
            <FormattedMessage id="schedule.createSchedule.welcomeMessageOptional" />
          </p>
        </div>
        <div className="ps-20 pt-2 flex space-x-2">
          <TextArea
            valid={true}
            rows={4}
            cols={100}
            className="w-[60%]"
            value={description}
            onChange={handleWelcomeMessage}
            placeholder={intl.formatMessage({
              id: "schedule.createSchedule.welcomeMessageHint",
            })}
          />
        </div>
      </div>
      <div className="flex justify-end w-full  pr-[25%] pb-[10%]">
        <Button themeColor={"primary"} onClick={handleCourseDataChange}>
          <FormattedMessage id="schedule.course.next" />
        </Button>
      </div>
    </div>
  );
}
